import { ChangeEvent, useState } from 'react'

import { SearchOutlined } from '@ant-design/icons'
import { useUpdateEffect } from 'ahooks'
import { Button, Input } from 'antd'
import { createStyles } from 'antd-style'

import { useUrlParams } from '@eastcoal/common/hooks/useUrlParams'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { useNavigate } from '@eastcoal/router/exports/react-router'

import { SEARCH_PAGE_PATH } from '../../../pages/Search/constants/path'

const useStyles = createStyles(({ token }) => ({
  container: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 120,
    marginBlockStart: token.marginSM,
    marginBlockEnd: token.marginXS,
    borderRadius: token.borderRadiusOuter,
    background:
      'linear-gradient(180deg, rgb(232, 238, 255) 0%, rgb(255, 255, 255) 100%)'
  }
}))

export const LayoutSearch = () => {
  const { keyword } = useUrlParams()
  const [value, setValue] = useState<string>(keyword)

  useUpdateEffect(() => {
    setValue(keyword)
  }, [keyword])

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
  }

  const navigate = useNavigate()
  const handleSearch = () => {
    const keyword = value?.trim()
    if (!keyword) return
    navigate(
      stringifyUrl({
        url: SEARCH_PAGE_PATH,
        query: { keyword }
      })
    )
  }

  const { styles } = useStyles()

  return (
    <div className={styles.container}>
      <Input
        allowClear
        autoComplete='true'
        name='searchKeyword'
        placeholder='请输入搜索的关键字，如：保证金、竞价报名、入金'
        size='large'
        style={{ width: 500 }}
        value={value}
        suffix={
          <Button
            icon={<SearchOutlined />}
            shape='circle'
            type='primary'
            onClick={handleSearch}
          />
        }
        onChange={handleChange}
        onPressEnter={handleSearch}
      />
    </div>
  )
}
